// extracted by mini-css-extract-plugin
export default {"content-box":"MyInfoWrite_content-box__FH3d1","inner-box":"MyInfoWrite_inner-box__V-36O","right":"MyInfoWrite_right__tXRJC","btn-group":"MyInfoWrite_btn-group__HXcT1"};